import { render, staticRenderFns } from "./actual-investor-inner-page-bottom-panel.vue?vue&type=template&id=68393b37&"
var script = {}
import style0 from "../../../../assets/styles/panels/_ActualInnerPageBottomPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports